import { render, staticRenderFns } from "./memberPrivileges.vue?vue&type=template&id=55acd43e&scoped=true"
import script from "./memberPrivileges.vue?vue&type=script&lang=js"
export * from "./memberPrivileges.vue?vue&type=script&lang=js"
import style0 from "./memberPrivileges.vue?vue&type=style&index=0&id=55acd43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acd43e",
  null
  
)

export default component.exports